module.exports = __webpack_public_path__ + "media/base/input_date-8c86757f.svg";